import { RollerShadeClosedIcon } from './RollerShadeClosedIcon';

/**
 * author: Google
 * id 796C645E-B8C8-4898-AE15-981077DEC280
 * name roller-shade-closed
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/roller-shade-closed.svg
 * tags
 * - Home Automation 
 */
export const BlindsClosedIcon = RollerShadeClosedIcon;
export default BlindsClosedIcon